import { DashboardCumulativeDatas } from "interface/admin/interface.dashboard";
import { TotlaMultiBoxWrap } from "style/admin/dashboard";
import { formatNumber } from "utils/util";
import {
  getTotalCountFromDateGroups,
  getTotalUserCount,
} from "utils/dashboard.util";
import { PeriodOption } from "./dashboard.select";
import renderComparisonBox from "./dashboard.render.comparison.box";
import { useEffect, useState } from "react";

interface DataProps {
  data: DashboardCumulativeDatas;
  period: PeriodOption;
  selectHandler: (selectItem: string) => void;
}

const DashboardMultiTotalBox = ({ data, period, selectHandler }: DataProps) => {
  const [activeKey, setActiveKey] = useState<string | null>("newUser");

  const periodLabelMap: Record<PeriodOption, string> = {
    daily: "전날",
    weekly: "전주",
    monthly: "전월",
  };

  useEffect(() => {
    if (!activeKey) return;
    selectHandler(activeKey);
  }, [activeKey]);

  const statsList = [
    {
      key: "newUser",
      current: getTotalUserCount(data.current.userTotalCount),
      previous: getTotalUserCount(data.previous.userTotalCount),
      label: "신규 가입자",
    },
    {
      key: "activeUser",
      current: getTotalUserCount(data.current.activeUserCount),
      previous: getTotalUserCount(data.previous.activeUserCount),
      label: "활성 사용자",
    },
    {
      key: "measure",
      current: getTotalCountFromDateGroups(data.current.simpleMeasureCount),
      previous: getTotalCountFromDateGroups(data.previous.simpleMeasureCount),
      label: "측정",
    },
    {
      key: "simpleTest",
      current: getTotalCountFromDateGroups(data.current.simpleTestCount),
      previous: getTotalCountFromDateGroups(data.previous.simpleTestCount),
      label: "간이검사",
    },
    {
      key: "deepTest",
      current: getTotalCountFromDateGroups(data.current.deepTestCount),
      previous: getTotalCountFromDateGroups(data.previous.deepTestCount),
      label: "심화검사",
    },
    {
      key: "review",
      current: getTotalCountFromDateGroups(data.current.reviewCount),
      previous: getTotalCountFromDateGroups(data.previous.reviewCount),
      label: "후기",
    },
  ];

  return (
    <TotlaMultiBoxWrap>
      {statsList.map(({ key, current, previous, label }) => (
        <div
          className={`box-item ${activeKey === key ? "active" : ""}`}
          key={key}
          onClick={() => setActiveKey(key)}
        >
          <p className="key">{label}</p>
          <h3 className="value">{formatNumber(current)}</h3>
          <div className="sub">
            {renderComparisonBox(current, previous)}
            <div className="previous">
              <span>{periodLabelMap[period]}</span>
              <span>{formatNumber(previous)}</span>
            </div>
          </div>
        </div>
      ))}
    </TotlaMultiBoxWrap>
  );
};

export default DashboardMultiTotalBox;
